module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple"
    }],
    class: [
      'component',
      'outline-button',
      _vm.active && 'active',
      _vm.label && 'has-text'
    ],
    on: {
      "click": function($event) {
        return _vm.$emit('click')
      }
    }
  }, [(_vm.icon) ? _c('icon', {
    attrs: {
      "name": _vm.icon,
      "scale": _vm.iconscale
    }
  }) : _vm._e(), _vm._v(" "), (_vm.label) ? _c('span', [_vm._v(_vm._s(_vm.label))]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-eac1490c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/OutlineButton.vue
// module id = 1036
// module chunks = 0